import { useDispatch, useSelector } from "react-redux";
import PendingTaskHeader from "../../components/pending-task-header/PendingTaskHeader";
import PendingTaskTile from "../../components/pending-task-tile/PendingTaskTile";
import SubjectApi from "../../services/subjectService";
import { useCallback, useEffect, useRef, useState } from "react";
import { PendingTasks } from "../../utils/formik/initialValues";
import EditorApi from "../../services/editorManagementService";
import TaskNotificationTile from "../../bmr/components/taskNotificationTile/TaskNotificationTile";
import { BackNavIcon } from "../../assets/common-svg/CommonSvg";
import { useLocation, useNavigate } from "react-router";
import { notify } from "../../bmr/utils/methods/notification";
import { fetchAllRoles, selectAllRoles } from "../../bmr/slices/roles";


const PendingTask = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const LoginData = useSelector((state) => state.loginData);
  const role_id = useSelector((state) => state.loginData.role_id);
  const bmr_modules = useSelector((state) => state.loginData).bmr_modules;
  const role_slug =LoginData.role_slug

  const singleModuleAccess = bmr_modules.length == 1 ? true : false;
  const [taskCount, setTaskCount] = useState({});
  const [search, setSearch] = useState("");
  const [isClosed, setIsClosed] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [taskData, setTaskData] = useState([]);
  // const [requestData, setRequestData] = useState([]);
  const [rolesData, setRolesData] = useState([]);
  const [phaseData, setPhaseData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [selectedIds, setSelectedIds] = useState(new Set());
const [isAllSelected, setIsAllSelected] = useState(false);
  const [page, setPage] = useState(1);
  const pageRef = useRef(1);
  const [loading, setLoading] = useState(true);
  const [maxPages, setMaxPages] = useState(null);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [categoryTabs, setCategoryTabs] = useState([]);
  const isChangeRequestView = location.pathname.includes("change-requests");
  const [alignment, setAlignment] = useState(
    isChangeRequestView ? `Pending CR` : `Pending Tasks`
  );
  const [filters, setFilters] = useState({});
  const [isArchived, setIsArchived] = useState(0);
  const isLoadingMore = useRef(false);
  const abortControllerRef = useRef(null);
  const allRoles = useSelector(selectAllRoles)

const normalizeCategoryIds = (category) => {
  if (Array.isArray(category)) {
    return category
      .map((item) => {
        if (item && typeof item === "object") {
          return item.id ?? item.key ?? item.value ?? null;
        }
        return item;
      })
      .filter((item) => item !== null && item !== undefined && item !== "");
  }

  if (category && typeof category === "object") {
    const value = category.id ?? category.key ?? category.value;
    return value !== null && value !== undefined && value !== "" ? [value] : [];
  }

  return category !== null && category !== undefined && category !== ""
    ? [category]
    : [];
};
const isArchivedAlignment = (viewAlignment = alignment) =>
  viewAlignment === "Archived CR" || viewAlignment === "Archived Tasks";

const getStatusForAlignment = (viewAlignment = alignment) =>
  viewAlignment.includes("Pending") || isArchivedAlignment(viewAlignment) ? 0 : 1;

const getArchivedValueForAlignment = (
  viewAlignment = alignment,
  fallbackArchivedValue = isArchived
) => (isArchivedAlignment(viewAlignment) ? 1 : fallbackArchivedValue ?? 0);
const handleSelectAll = (checked) => {
  if (checked) {
    const allIds = new Set(taskData.map((t) => t.id));
    setSelectedIds(allIds);
    setIsAllSelected(true);
  } else {
    setSelectedIds(new Set());
    setIsAllSelected(false);
  }
};
useEffect(() => {
  if (taskData.length === 0) {
    setIsAllSelected(false);
    return;
  }

  setIsAllSelected(selectedIds.size === taskData.length);
}, [selectedIds, taskData]);
useEffect(() => {
  if (taskData.length > 0 && selectedIds.size > 0) {
    const existingIds = new Set(taskData.map(t => t.id));
    const validSelectedIds = new Set(
      Array.from(selectedIds).filter(id => existingIds.has(id))
    );
    
    if (validSelectedIds.size !== selectedIds.size) {
      setSelectedIds(validSelectedIds);
      setIsAllSelected(validSelectedIds.size === taskData.length);
    }
  } else if (taskData.length === 0) {
    setSelectedIds(new Set());
    setIsAllSelected(false);
  }
}, [taskData]);
  // Helper function to validate search input
  const isValidSearchInput = (searchValue) => {
    if (!searchValue || searchValue.trim() === "") {
      return searchValue === "";
    }
    if (searchValue.endsWith(" ") && searchValue.trim().length > 0) {
      return false;
    }
    return true;
  };
    const getAllRoleDropDown = async () => {
      await dispatch(fetchAllRoles(true))
    };

  // Helper function to get clean search value for API
  const getCleanSearchValue = (searchValue) => {
    return searchValue ? searchValue.trim() : "";
  };

  // FIXED: Improved API call function with proper state management
  const handleGetHistoryData = useCallback(
    async (
      status = null,
      optionalfilter = {},
      isLoadMore = false,
      targetPage = 1,
      category = "",
      archivedFilter = 0  
    ) => {

      // Cancel previous request if exists
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      // Prevent duplicate calls
      if (isLoadingMore.current && isLoadMore) return;

      // Validate search input before making API call
      if (!isValidSearchInput(search)) {
        return;
      }

      // Create new abort controller
      abortControllerRef.current = new AbortController();

      if (isLoadMore) {
        isLoadingMore.current = true;
      } else {
        setLoading(true);
        // Reset pagination for new searches/filters
        setTaskData([]);
        setHasMoreData(true);
      }

      // Convert status to integer if it's provided, otherwise determine from alignment
      let statusInt;
      if (status !== null) {
        statusInt = parseInt(status);
      } else {
        statusInt = (alignment.includes("Pending") || alignment === "Archived Tasks" || alignment === "Archived CR") ? 0 : 1;
      }
      const isClosed = statusInt === 1;
      const archiveFilterValue = isClosed
        ? undefined
        : (archivedFilter !== null && archivedFilter !== undefined
          ? archivedFilter
          : isArchived ?? 0);
      setIsClosed(isClosed);

      try {
        let response;
        const cleanSearchValue = getCleanSearchValue(search);

        if (isChangeRequestView) {
          const categoryIds = normalizeCategoryIds(category);
          const payload = {
            page: targetPage,
            limit: 10,
            change_request_reason_id:
              categoryIds.length > 0 ? categoryIds.join(",") : undefined,
               is_history: alignment === "History CR" ? true : false,
          };

          const filter = {
            filter: {
              status: statusInt.toString(),
              search: cleanSearchValue,

              ...optionalfilter,
            },
          };
          response = await SubjectApi.requestHistory(
            payload.limit,
            payload.page,
            optionalfilter.phase_id,
            payload.subject_id,
            filter,
            payload.change_request_reason_id,
            archiveFilterValue,
            payload.is_history
          );
        } else {
          const categoryIds = normalizeCategoryIds(category);
          const filter = {
            ...(archiveFilterValue !== 1 && { status: statusInt }),
            search: cleanSearchValue,
            sort_by: null,
            is_archived: archiveFilterValue,
            ...optionalfilter,
            ...(categoryIds.length > 0 ? { category: categoryIds.join(",") } : {}),
          };

          response = await SubjectApi.tasklist(10, targetPage, filter);
        }

        // Check if request was aborted
        if (abortControllerRef.current?.signal?.aborted) {
          return;
        }

        if (response?.stats) {
          setTaskCount(response);
        } 
         else if (!isLoadMore) {
  setTaskCount({}); 
}
        else {
          setTaskCount({});
        }

        if (response?.data?.length) {
          setTaskData((prev) => {
            if (isLoadMore) {
              // Avoid duplicates by checking if items already exist
              const existingIds = new Set(prev.map((item) => item.id));
              const newItems = response.data.filter(
                (item) => !existingIds.has(item.id)
              );
              return [...prev, ...newItems];
            } else {
                setSelectedIds(new Set());
          setIsAllSelected(false);
              return response.data;
            }
          });

          // Check if we have more data
          // const hasMore = response.data.length >= 10;
          // setHasMoreData(hasMore);
        } else {
          if (!isLoadMore) {
            setTaskData([]);
          }
          setHasMoreData(false);
        }

        if (response?.page_details) {
          const calculatedMaxPages = Math.ceil(
            response.page_details.no_of_records / response.page_details.limit
          );
          setMaxPages(calculatedMaxPages);
          setHasMoreData(targetPage < calculatedMaxPages);
        }
          setLoading(false);
      } catch (error) {
         setLoading(false);
        if (error.name === "AbortError") {
          return;
        }

        console.error("API Error:", error);
        notify.error(error?.message || error || "Failed to fetch data")
        setHasMoreData(false);
      } finally {
        isLoadingMore.current = false;
        abortControllerRef.current = null;
      }
    },
    [alignment, search, dispatch, role_id, isArchived, isChangeRequestView]
  );

useEffect(() =>{
const final = allRoles?.map((it) => ({ 
  name: it.title, 
  id: it.id 
}));
  setRolesData(final || [])
  },[allRoles])

  const handleFilterSubmit = (p, v) => {
    if (!p) p = {};
    let sendOptionalParameter = {};
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        sendOptionalParameter[key] = p[key];
      }
    });
    if (v?.from) sendOptionalParameter.startDate = v.from;
    if (v?.to) sendOptionalParameter.endDate = v.to;
    setFilters(sendOptionalParameter);
    updatePage(1);
    setHasMoreData(true);

    // Trigger data fetch with new filters
    const status = getStatusForAlignment();
    const archivedValue = getArchivedValueForAlignment();
    handleGetHistoryData(status, sendOptionalParameter, false, 1, selectedCategory, archivedValue);
  };
  const handleArchiveTasks = async (taskIds) => {
    try {
      setLoading(true);
      const idsArray = Array.from(taskIds);
      if(isChangeRequestView) {
        await SubjectApi.changeRequests(idsArray, 1);
      } else {
        await SubjectApi.archiveChangeRequests(idsArray, 1);
      }
      
 if (isArchived !== 1)  {
      setTaskData(prev => prev.filter(task => !taskIds.has(task.id)));
    }
      setSelectedIds(new Set());
      setIsAllSelected(false);
      notify.success(`${idsArray.length} Task archived successfully`);
      refreshAction();
    } catch (error) {
      console.error(error);
      notify.error("Failed to archive CR");
    } finally {
      setLoading(false);
    }
  };
  const handleUnarchiveTasks = async (taskIds) => {
    try {
      setLoading(true);
      const idsArray = Array.from(taskIds);
      if(isChangeRequestView)
        await SubjectApi.changeRequests(idsArray, 0);
        else
      await SubjectApi.archiveChangeRequests(idsArray, 0); 
         if (isArchived === 1) {
      setTaskData(prev => prev.filter(task => !taskIds.has(task.id)));
    }
      setSelectedIds(new Set());
      setIsAllSelected(false);
      notify.success(`${idsArray.length} Task unarchived successfully`);
      refreshAction();
    } catch (error) {
      console.error(error);
      notify.error("Failed to unarchive Task");
    } finally {
      setLoading(false);
    }
  };
  const handleTaskResolved = (taskId) => {
    if (!taskId) return;

    setTaskData((prev) => prev.filter((task) => task.id !== taskId));
    setSelectedIds((prev) => {
      const next = new Set(prev);
      next.delete(taskId);
      return next;
    });

    setTaskCount((prev) => {
      const stats = prev?.stats;
      if (!stats || !alignment.includes("Pending")) return prev;

      return {
        ...prev,
        stats: {
          ...stats,
          pending_count: Math.max((stats.pending_count ?? 0) - 1, 0),
          closed_count: (stats.closed_count ?? 0) + 1,
        },
      };
    });
  };

  const handlePhaseSearch = (value) => {
    setSearch(value);
    setPage(1);
    setHasMoreData(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  const handleExportPendingTask = async () => {
    try {
      const res = await SubjectApi.exportRequestListById(
        null,
        alignment.includes("Pending") ? 0 : 1
      );
      if (!res) {
        notify.error(res?.message)
      } else {
        const blob = new Blob([res], { type: "text/plain" });
        const fileURL = URL.createObjectURL(blob);
        const downloadLink = document.createElement("a");
        downloadLink.href = fileURL;
        downloadLink.download = "request_reason.csv";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        URL.revokeObjectURL(fileURL);
      }
    } catch (error) {
      notify.error(error)
    }
  };

  const handlePendingFilter = () => {
    getAllPhaseDropDown();
    setOpenFilter(true);
  };

  const getStatusDropDown = async () => {
    try {
      //  let result;
      if(isChangeRequestView){
        const res = await SubjectApi.getCategoryTiles();
      setCategoryTabs(res.data.map((item) => ({
    key: item.id, 
    label: item.title,
  })));
      }else{
        const res = await SubjectApi.getAllCategory();
setCategoryTabs(res.data.map((item) => ({
  key: item.category_reason,   
  label: item.title,           
})));
      } 
    } catch (error) {
      notify.error(error)
    }
  };
const updatePage = (val) => {
  setPage(val);
  pageRef.current = val;
};
  const getAllPhaseDropDown = async () => {
    try {
      let editor_id = undefined;
      let user_id = undefined;
      let investigator_id = undefined;

      if (role_slug === 'editor') {
        editor_id = LoginData.loginId;
      }

      if (role_slug === 'investigator') {
        investigator_id = LoginData.loginId;
      }
      if (role_slug === 'project-manager') {
        user_id = LoginData.loginId;
      }
      const res = await EditorApi.getPhaseDropDown("", // search
        investigator_id, // investigator_id
        editor_id, // editor_id (only for role 5)
        user_id);
      const result = res.data.map((item) => ({
        id: item.id,
        name: `${item.title}${
          item.product_details?.name ? ` (${item.product_details.name})` : ""
        }`,
      }));
      const productResult = res.data
        .filter((item) => item.product_details)
        .map((item) => ({
          id: item.product_details.id,
          name: item.product_details.name,
        }));
      const uniqueProductData = Array.from(
        new Map(productResult.map((item) => [item.id, item])).values()
      ).sort((a, b) => a.name.localeCompare(b.name));
      setProductData(uniqueProductData);
      setPhaseData(result);
    } catch (error) {
        notify.error(error)
    }
  };

  // FIXED: Improved loadMoreData function
  const loadMoreData = useCallback(() => {
    if (!hasMoreData || isLoadingMore.current || loading) {
      return;
    }
const currentPage = pageRef.current;
    if (maxPages && page >= maxPages) {
      setHasMoreData(false);
      return;
    }

    const nextPage = currentPage + 1;
    updatePage(nextPage);

    const status = getStatusForAlignment();
    const archivedValue = getArchivedValueForAlignment();
    handleGetHistoryData(status, filters, true, nextPage,selectedCategory, archivedValue);
  }, [
    hasMoreData,
    loading,
    maxPages,
    alignment,
    filters,
    handleGetHistoryData,
    selectedCategory
  ]);

  // FIXED: Separate useEffect for initial data and alignment changes
  // useEffect(() => {
  //   if (isValidSearchInput(search)) {
  //     const status = alignment.includes("Pending") ? 0 : 1;
  //     // setPage(1);
  //     updatePage(1);
  //     handleGetHistoryData(status, filters, false, 1);
  //   }
  // }, [alignment]); // Only trigger on alignment change

    const refreshAction = (category=selectedCategory) => {
    const status = getStatusForAlignment();
      const archivedValue = getArchivedValueForAlignment();
    updatePage(1);
     handleGetHistoryData(status, filters, false, 1, category,archivedValue);
    }

  // FIXED: Separate useEffect for search changes with debouncing
  useEffect(() => {
    if (isValidSearchInput(search)) {
      const timeoutId = setTimeout(() => {
        const status = getStatusForAlignment();
        const archivedValue = getArchivedValueForAlignment();
        updatePage(1);
        handleGetHistoryData(status, filters, false, 1, selectedCategory, archivedValue);
      //  refreshAction();
      }, 300); // 300ms debounce

  return () => clearTimeout(timeoutId);
    }
}, [alignment, search, filters]);

useEffect(() => {
  if (!isLoadingMore.current) {
    const status = getStatusForAlignment();
    const archivedValue = getArchivedValueForAlignment();
    updatePage(1);
    handleGetHistoryData(status, filters, false, 1, selectedCategory, archivedValue);
  }
}, [isArchived, alignment]);
  // Initial data loading
  useEffect(() => {
   getAllRoleDropDown();
    getStatusDropDown();
    getAllPhaseDropDown();
  }, []);

  useEffect(() => {
    setAlignment(isChangeRequestView ? "Pending CR" : "Pending Tasks");
    setSelectedCategory([]);
    setCategoryTabs([]);
    setFilters({});
    setIsArchived(0);
    updatePage(1);
    getStatusDropDown(); 
  }, [isChangeRequestView]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);
  const isModalOpenRef = useRef(false);
  useEffect(() => {
    const syncLatestTaskState = () => {
       if (isModalOpenRef.current) return;
      if (document.visibilityState === "visible") {
        refreshAction();
      }
    };

    window.addEventListener("focus", syncLatestTaskState);
    document.addEventListener("visibilitychange", syncLatestTaskState);

    return () => {
      window.removeEventListener("focus", syncLatestTaskState);
      document.removeEventListener("visibilitychange", syncLatestTaskState);
    };
  }, [alignment, filters, selectedCategory, isArchived]);

  const handleNavigate = () => {
    navigate("/");
  };

  const handleNavigate2 = () => {
    if (role_id === 10) {
      navigate("/bmr/lsm");
    } else if (role_id === 9) {
      navigate("/bmr/logistics-management/in-bound");
    } else {
      navigate("/bmr/feasibility-assessment/subjects");
    }
  };

  const handleCategoryChange = (tabKeys = []) => {
  setSelectedCategory(tabKeys);
  updatePage(1);
  setHasMoreData(true);
  const status = getStatusForAlignment();
  const archivedValue = getArchivedValueForAlignment();
  handleGetHistoryData(status, filters, false, 1, tabKeys, archivedValue);
};
const handleArchivedFilterChange = (value) => {
  let newArchivedValue;
  if (value === null || value === undefined || value === "") {
    newArchivedValue = 0;
  } else {
    const parsed = parseInt(value, 10);
    newArchivedValue = isNaN(parsed) ? 0 : parsed;
  }
  
  setIsArchived(newArchivedValue);
  updatePage(1);

   const status = getStatusForAlignment();
  const archivedValue = getArchivedValueForAlignment(alignment, newArchivedValue);
  handleGetHistoryData(status, filters, false, 1, selectedCategory, archivedValue);
};
  // Conditional rendering function for the tile component
  const renderTaskTile = () => {
    return isChangeRequestView ? (
      <PendingTaskTile
        task={taskData}
        isClosed={isClosed}
        loadMoreData={loadMoreData}
        page={page}
         refreshAgain={refreshAction}
        maxPages={maxPages}
        loading={loading}
        alignment={alignment}
        hasMoreData={hasMoreData}
        selectedIds={selectedIds}
        setSelectedIds={setSelectedIds}
        onArchiveTask={handleArchiveTasks}
        onUnarchiveTask={handleUnarchiveTasks}
        isArchived={isArchived}  
        canSelect={!alignment.includes("Closed")}
        onTaskResolved={handleTaskResolved}
      />
    ) : (
      <TaskNotificationTile
        task={taskData}
        isClosed={isClosed}
        loadMoreData={loadMoreData}
        page={page}
        maxPages={maxPages}
        loading={loading}
        alignment={alignment}
        hasMoreData={hasMoreData}
        selectedIds={selectedIds}
        setSelectedIds={setSelectedIds}
        onArchiveTask={handleArchiveTasks}
        onUnarchiveTask={handleUnarchiveTasks}
        isArchived={isArchived}  
          canSelect={!isClosed}
           isModalOpenRef={isModalOpenRef}
        refreshAction={refreshAction}
        
      />
    );
  };

  return (
    <div>
      <div className="flex flex-col gap-4 mt-4 ml-4 mr-4">
       <div
        className="cursor-pointer flex items-center mb-0 gap-1 w-[fit-content]"
        onClick={singleModuleAccess ? handleNavigate2 : handleNavigate}
      >
        <div className="block p-2 !pl-0 w-max">
          <BackNavIcon width={18} height={18} />
        </div>
        <span className="!m-0">Back</span>
      </div>
        <PendingTaskHeader
          SearchbarPlaceholder="Search by Product/Phase/Patient name"
          width={"100%"}
          handleButtonClick={handlePendingFilter}
          handleSearch={handlePhaseSearch}
          showExportButton={role_id === 1}
          handleExportButton={handleExportPendingTask}
          taskCount={taskCount}
          openFilter={openFilter}
          closeFilter={handleCloseFilter}
          setOpenFilter={setOpenFilter}
          handleFilterSubmit={handleFilterSubmit}
          handleGetHistoryData={handleGetHistoryData}
          setAlignment={setAlignment}
          alignment={alignment}
          // requestData={requestData}
          rolesData={rolesData}
          phaseData={phaseData}
          productData={productData}
          initialVal={PendingTasks}
          page={page}
          setPage={updatePage}
          setFilters={setFilters}
          onCategoryChange={handleCategoryChange}
          categoryTabs={categoryTabs}
          selectedCategory={selectedCategory}
          isArchived={isArchived}
          onArchivedFilterChange={handleArchivedFilterChange}
          isAllSelected={isAllSelected}
          totalItemsCount={taskData.length}
          onSelectAll={handleSelectAll}
          isClosed={alignment.includes("Closed")}
          isChangeRequestView={isChangeRequestView}
        />
      </div>
      <div className={`px-4 pt-3 ${isClosed ? "h-[calc(100vh-260px)]" : "h-[calc(100vh-377px)]"} flex flex-col overflow-hidden`}>{renderTaskTile()}</div>
    </div>
  );
};

export default PendingTask;
